module.exports = __webpack_public_path__ + "static/media/img-background2.cc96f136.jpg";